module.exports = __webpack_public_path__ + "img/acordo_1.726915da.png";